import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import { LoadingProvider } from './context/LoadingContext'
import { ModalProvider } from './context/ModalContext'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

const rootElement = document.getElementById('root')

if (rootElement) {
	const root = ReactDOM.createRoot(rootElement)
	root.render(
		<React.StrictMode>
			<BrowserRouter>
				<LoadingProvider>
					<ModalProvider>
						<App />
						<ToastContainer
							position="top-right"
							autoClose={2500}
							hideProgressBar={false}
							newestOnTop
							closeOnClick
							pauseOnHover
							draggable
							theme="light"
						/>
					</ModalProvider>
				</LoadingProvider>
			</BrowserRouter>
		</React.StrictMode>,
	)
} else {
	console.error('Root element not found')
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
